import React, {useCallback} from 'react';
import {RACK_CONFIGURATION_OPTION} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import Dropdown from 'react-dropdown';
import {effectOptions, getEffectOption, initializeEffect} from './constants.js';

const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

export default ({rack, routingNumber}) => {
    const chooseRouting = useCallback((e) => {
        e.target.blur();
        let id = parseInt(e.target.value);
        rack.currentConfiguration = id;
    }, []);

    const options = rack.configurations.map(
        (x, i) => ({
            label: NAMES[i],
            value: parseInt(i)
        }));

    return (
        <Documented
          element={RACK_CONFIGURATION_OPTION}
          className="routing-chooser" >
          <form>
            {options.map(
                option =>
                    <label key={option.label}>
                      {option.label}
                      <input
                        type="radio"
                        value={option.value}
                        onChange={chooseRouting}
                        checked={routingNumber === option.value} />
                    </label>)}
          </form>
        </Documented>
    );
}
